import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import MainPage from './pages/MainPage';
import Tools from './pages/Tools';
import AlphaAnalyzer from './pages/Tools/AlphaAnalyzer';
import MarketSentiment from './pages/Tools/MarketSentiment';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<MainPage />} />

          {/* Redirects for old URLs to maintain bookmarks */}
          <Route path="/story" element={<Navigate to="/#story" replace />} />
          <Route path="/team" element={<Navigate to="/#team" replace />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />

          {/* Tools routes (hidden from navbar) */}
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/alpha-analyzer" element={<AlphaAnalyzer />} />
          <Route path="/tools/screener" element={<AlphaAnalyzer />} />
          <Route path="/tools/market-sentiment" element={<MarketSentiment />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
